import SuccessfulFuru from './SuccessfulUseFuru.png';
import SuccessfulVoucher from './SuccessfulUseVoucher.png';
import NoImage from './noImage.svg';

const ComeBackIcon = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 14}
      height={height ? height : 10}
      fill={color ? color : 'none'}
      viewBox="0 0 14 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 5L1.5 5M1.5 5L6.08824 9M1.5 5L6.08824 1"
        stroke="#595959"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const V2ComeBackIcon = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 14}
      height={height ? height : 10}
      fill={color ? color : '#000000'}
      // fill="#000000"
      // height="800px"
      // width="800px"
      version="1.1"
      // id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26.676 26.676"
    >
      <g>
        <path
          d="M26.105,21.891c-0.229,0-0.439-0.131-0.529-0.346l0,0c-0.066-0.156-1.716-3.857-7.885-4.59
          c-1.285-0.156-2.824-0.236-4.693-0.25v4.613c0,0.213-0.115,0.406-0.304,0.508c-0.188,0.098-0.413,0.084-0.588-0.033L0.254,13.815
          C0.094,13.708,0,13.528,0,13.339c0-0.191,0.094-0.365,0.254-0.477l11.857-7.979c0.175-0.121,0.398-0.129,0.588-0.029
          c0.19,0.102,0.303,0.295,0.303,0.502v4.293c2.578,0.336,13.674,2.33,13.674,11.674c0,0.271-0.191,0.508-0.459,0.562
          C26.18,21.891,26.141,21.891,26.105,21.891z"
        />
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </g>
    </svg>
  );
};

const MenuIcon = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 4}
      height={height ? height : 18}
      fill={color ? color : 'none'}
      viewBox="0 0 4 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM2 14C0.9 14 0 14.9 0 16C0 17.1 0.9 18 2 18C3.1 18 4 17.1 4 16C4 14.9 3.1 14 2 14ZM2 7C0.9 7 0 7.9 0 9C0 10.1 0.9 11 2 11C3.1 11 4 10.1 4 9C4 7.9 3.1 7 2 7Z"
        fill="#434343"
      />
    </svg>
  );
};

const ClockIcon = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 14}
      height={height ? height : 15}
      fill={color ? color : 'none'}
      viewBox="0 0 14 15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00004 14.1666C3.31804 14.1666 0.333374 11.1819 0.333374 7.49992C0.333374 3.81792 3.31804 0.833252 7.00004 0.833252C10.682 0.833252 13.6667 3.81792 13.6667 7.49992C13.6667 11.1819 10.682 14.1666 7.00004 14.1666ZM7.00004 12.8333C8.41453 12.8333 9.77108 12.2713 10.7713 11.2712C11.7715 10.271 12.3334 8.91441 12.3334 7.49992C12.3334 6.08543 11.7715 4.72888 10.7713 3.72868C9.77108 2.72849 8.41453 2.16659 7.00004 2.16659C5.58555 2.16659 4.229 2.72849 3.2288 3.72868C2.22861 4.72888 1.66671 6.08543 1.66671 7.49992C1.66671 8.91441 2.22861 10.271 3.2288 11.2712C4.229 12.2713 5.58555 12.8333 7.00004 12.8333ZM7.66671 7.49992H10.3334V8.83325H6.33337V4.16659H7.66671V7.49992Z"
        fill="#595959"
      />
    </svg>
  );
};

const PhotoFrames = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 19}
      height={height ? height : 18}
      fill={color ? color : 'none'}
      viewBox="0 0 19 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 0H18.5V5H16.5V2H12.5V0ZM6.5 0V2H2.5V5H0.5V0H6.5ZM12.5 18V16H16.5V13H18.5V18H12.5ZM6.5 18H0.5V13H2.5V16H6.5V18ZM0.5 8H18.5V10H0.5V8Z"
        fill="#434343"
      />
    </svg>
  );
};

const EditIcon = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 12}
      height={height ? height : 12}
      fill={color ? color : 'none'}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.6 2.57199L9.428 5.40066L2.828 12H0V9.17133L6.6 2.57133V2.57199ZM7.54267 1.62933L8.95667 0.214661C9.08169 0.0896806 9.25122 0.0194702 9.428 0.0194702C9.60478 0.0194702 9.77432 0.0896806 9.89933 0.214661L11.7853 2.10066C11.9103 2.22568 11.9805 2.39522 11.9805 2.57199C11.9805 2.74877 11.9103 2.91831 11.7853 3.04333L10.3707 4.45733L7.54267 1.62933Z"
        fill="#434343"
      />
    </svg>
  );
};

const VisaIcon = ({ color, width, height, className }: any) => {
  return (
    // <svg
    // className={className}
    // width={width ? width : 22}
    // height={height ? height : 16}
    // fill={color ? color : 'none'}
    //   viewBox="0 0 22 16"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M0 0H22V2H0V0ZM0 14H22V16H0V14ZM18.622 10.914L18.448 10.044H16.499L16.189 10.907L14.627 10.91C15.632 8.504 16.377 6.72 16.863 5.562C16.99 5.259 17.216 5.105 17.548 5.107C17.802 5.109 18.217 5.109 18.793 5.107L20 10.912L18.622 10.915V10.914ZM16.938 8.852H18.194L17.724 6.672L16.938 8.852ZM6.872 5.106L8.442 5.108L6.015 10.914L4.425 10.913C3.888 8.843 3.493 7.307 3.241 6.308C3.164 6.001 3.011 5.787 2.715 5.686C2.452 5.596 2.014 5.456 1.4 5.267V5.107H3.909C4.343 5.107 4.596 5.317 4.678 5.747L5.298 9.036L6.872 5.106ZM10.599 5.108L9.359 10.913L7.864 10.911L9.104 5.106L10.599 5.108ZM13.631 5C14.077 5 14.641 5.138 14.965 5.267L14.703 6.471C14.41 6.353 13.928 6.194 13.523 6.201C12.933 6.21 12.569 6.457 12.569 6.694C12.569 7.078 13.201 7.272 13.853 7.693C14.596 8.173 14.693 8.603 14.684 9.071C14.674 10.042 13.853 11 12.12 11C11.329 10.988 11.044 10.922 10.4 10.694L10.672 9.438C11.328 9.712 11.607 9.799 12.167 9.799C12.682 9.799 13.123 9.592 13.127 9.231C13.129 8.974 12.972 8.847 12.395 8.529C11.818 8.212 11.01 7.773 11.02 6.889C11.033 5.759 12.107 5 13.63 5H13.631Z"
    //     fill="#"
    //   />
    // </svg>
    <svg
      className={className}
      width={width ? width : 22}
      height={height ? height : 16}
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: '1.41421',
      }}
      version="1.1"
      viewBox="0 0 900 575"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g transform="matrix(4.16667,0,0,4.16667,0,0)">
        <rect height="137.21" style={{ fill: 'white', fillRule: 'nonzero' }} width={216} x={0} y="0.79" />
        <rect
          height="18.72"
          style={{ fill: 'rgb(252,179,21)', fillRule: 'nonzero' }}
          width="208.802"
          x="3.597"
          y="115.705"
        />
        <rect
          height="18.72"
          style={{ fill: 'rgb(13,53,127)', fillRule: 'nonzero' }}
          width="208.802"
          x="3.597"
          y="4.389"
        />
        <path
          d="M106.197,43.734L95.191,95.189L81.879,95.189L92.886,43.734L106.197,43.734ZM162.201,76.959L169.209,57.636L173.24,76.959L162.201,76.959ZM177.061,95.189L189.369,95.189L178.615,43.734L167.261,43.734C164.701,43.734 162.545,45.218 161.59,47.506L141.615,95.189L155.596,95.189L158.371,87.504L175.447,87.504L177.061,95.189ZM142.309,78.39C142.367,64.811 123.537,64.058 123.662,57.991C123.703,56.147 125.461,54.183 129.307,53.681C131.213,53.435 136.473,53.237 142.436,55.984L144.768,45.068C141.564,43.91 137.443,42.794 132.316,42.794C119.156,42.794 109.898,49.784 109.824,59.802C109.74,67.21 116.438,71.34 121.473,73.807C126.664,76.329 128.404,77.947 128.379,80.2C128.343,83.652 124.238,85.18 120.418,85.238C113.721,85.342 109.84,83.428 106.746,81.986L104.33,93.266C107.445,94.692 113.186,95.933 119.129,95.997C133.119,95.997 142.268,89.088 142.309,78.39ZM87.176,43.734L65.607,95.189L51.537,95.189L40.922,54.124C40.279,51.599 39.718,50.671 37.761,49.604C34.56,47.865 29.275,46.239 24.629,45.227L24.943,43.734L47.595,43.734C50.48,43.734 53.076,45.654 53.736,48.977L59.343,78.754L73.191,43.734L87.176,43.734Z"
          style={{ fill: 'rgb(13,53,127)', fillRule: 'nonzero' }}
        />
      </g>
    </svg>
  );
};

const MastercardIcon = ({ color, width, height, className }: any) => {
  return (
    // <svg
    //   className={className}
    //   width={width ? width : 22}
    //   height={height ? height : 16}
    //   fill={color ? color : 'none'}
    //   viewBox="0 0 22 16"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M11 14.294C9.89111 14.9455 8.62977 15.2925 7.34366 15.2998C6.05755 15.3072 4.79232 14.9746 3.67606 14.3358C2.55979 13.697 1.63212 12.7746 0.98693 11.662C0.341744 10.5494 0.00195313 9.28608 0.00195312 7.99995C0.00195313 6.71382 0.341744 5.45052 0.98693 4.33792C1.63212 3.22532 2.55979 2.30293 3.67606 1.66411C4.79232 1.02529 6.05755 0.692723 7.34366 0.70007C8.62977 0.707418 9.89111 1.05442 11 1.70595C12.1089 1.05442 13.3702 0.707418 14.6563 0.70007C15.9425 0.692723 17.2077 1.02529 18.3239 1.66411C19.4402 2.30293 20.3679 3.22532 21.0131 4.33792C21.6583 5.45052 21.9981 6.71382 21.9981 7.99995C21.9981 9.28608 21.6583 10.5494 21.0131 11.662C20.3679 12.7746 19.4402 13.697 18.3239 14.3358C17.2077 14.9746 15.9425 15.3072 14.6563 15.2998C13.3702 15.2925 12.1089 14.9455 11 14.294ZM12.702 12.91C13.5067 13.237 14.3794 13.3612 15.2434 13.2718C16.1074 13.1823 16.9361 12.8819 17.6567 12.3969C18.3773 11.9119 18.9676 11.2573 19.3758 10.4905C19.784 9.72383 19.9975 8.86855 19.9975 7.99995C19.9975 7.13136 19.784 6.27607 19.3758 5.50936C18.9676 4.74264 18.3773 4.088 17.6567 3.60302C16.9361 3.11805 16.1074 2.81761 15.2434 2.72814C14.3794 2.63867 13.5067 2.76292 12.702 3.08995C13.9255 4.43222 14.6026 6.18371 14.6 7.99995C14.6 9.88995 13.881 11.614 12.702 12.91ZM9.298 3.08995C8.49332 2.76292 7.6206 2.63867 6.75662 2.72814C5.89265 2.81761 5.0639 3.11805 4.34331 3.60302C3.62271 4.088 3.03236 4.74264 2.62418 5.50936C2.21601 6.27607 2.00253 7.13136 2.00253 7.99995C2.00253 8.86855 2.21601 9.72383 2.62418 10.4905C3.03236 11.2573 3.62271 11.9119 4.34331 12.3969C5.0639 12.8819 5.89265 13.1823 6.75662 13.2718C7.6206 13.3612 8.49332 13.237 9.298 12.91C8.07446 11.5677 7.3974 9.81619 7.4 7.99995C7.4 6.10995 8.119 4.38595 9.298 3.08995ZM11 4.20495C10.4928 4.69819 10.0899 5.28826 9.81504 5.94015C9.5402 6.59204 9.39906 7.29249 9.4 7.99995C9.4 9.48795 10.013 10.832 11 11.795C11.5072 11.3017 11.9101 10.7116 12.185 10.0598C12.4598 9.40786 12.6009 8.70741 12.6 7.99995C12.6009 7.29249 12.4598 6.59204 12.185 5.94015C11.9101 5.28826 11.5072 4.69819 11 4.20495Z"
    //     fill={color ? color : '#434343'}
    //   />
    // </svg>
    <svg
      className={className}
      width={width ? width : 22}
      height={height ? height : 16}
      fill={color ? color : 'none'}
      enableBackground="new 0 0 32 20"
      overflow="visible"
      viewBox="0 0 32 20"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <g id="Master_Card_1_">
          <g id="Master_Card">
            <circle cx={10} cy={10} fill="#F93232" id="Red_x5F_Circle" r={10} />
            <path
              d="M22,0c-2.246,0-4.312,0.75-5.98,2H16v0.014        C15.604,2.312,15.24,2.648,14.893,3h2.214c0.308,0.313,0.592,0.648,0.855,1H14.03c-0.242,0.319-0.464,0.652-0.667,1h5.264        c0.188,0.324,0.365,0.654,0.518,1h-6.291c-0.143,0.325-0.269,0.658-0.377,1h7.044c0.104,0.326,0.186,0.661,0.258,1h-7.563        c-0.067,0.328-0.123,0.66-0.157,1h7.881C19.979,9.328,20,9.661,20,10h-8c0,0.339,0.027,0.67,0.06,1h7.882        c-0.038,0.339-0.093,0.672-0.162,1h-7.563c0.069,0.341,0.158,0.673,0.261,1h7.044c-0.108,0.342-0.234,0.675-0.377,1h-6.291        c0.151,0.344,0.321,0.678,0.509,1h5.264c-0.202,0.348-0.427,0.681-0.669,1H14.03c0.266,0.352,0.553,0.687,0.862,1h2.215        c-0.348,0.353-0.711,0.688-1.107,0.986C17.672,19.245,19.745,20,22,20c5.523,0,10-4.478,10-10S27.523,0,22,0z"
              fill="#FED049"
              id="Yellow_x5F_Circle"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const MenuHome = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 20}
      height={height ? height : 20}
      fill={color ? color : 'none'}
      viewBox="0 0 22 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.875 15.3339V16.0008H1.875V15.3341H3.04167H3.54167V14.8341V8.90665V8.508L3.15303 8.41921C2.48067 8.26559 1.87455 7.90223 1.42221 7.3816C1.10884 7.02092 0.880524 6.59771 0.750464 6.14321C2.38155 6.27094 4.01899 5.89584 5.43821 5.05957C6.95663 4.16484 8.13431 2.79579 8.79333 1.16831H8.95782C9.61669 2.79524 10.7939 4.16391 12.3117 5.05861C13.7307 5.89506 15.368 6.27044 16.999 6.14303C16.8691 6.59762 16.6409 7.02095 16.3276 7.3817C15.8753 7.90233 15.2693 8.26567 14.597 8.4192L14.2083 8.50796V8.90665V14.8333V15.3331L14.7081 15.3333L15.875 15.3339ZM13.5417 8.99998V8.49998H13.0417H4.70834H4.20834V8.99998V14.8333V15.3333H4.70834H13.0417H13.5417V14.8333V8.99998Z"
        fill={color ? color : '#8C8C8C'}
      />
    </svg>
  );
};

const ScanIcon = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 12}
      height={height ? height : 12}
      fill={color ? color : 'none'}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0H12V3.33333H10.6667V1.33333H8V0ZM4 0V1.33333H1.33333V3.33333H0V0H4ZM8 12V10.6667H10.6667V8.66667H12V12H8ZM4 12H0V8.66667H1.33333V10.6667H4V12ZM0 5.33333H12V6.66667H0V5.33333Z"
        fill={color ? color : '#9254DE'}
      />
    </svg>
  );
};

const MenuWhatIs = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 20}
      height={height ? height : 20}
      fill={color ? color : 'none'}
      viewBox="0 0 22 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.09013 7.97573L7.22639 8.08334H7.40001H9.20834C10.0703 8.08334 10.8969 8.42575 11.5064 9.03524C11.9968 9.52561 12.3143 10.1565 12.4197 10.8333H7.12418H6.62368L6.62418 11.3338L6.62501 12.1672L6.62551 12.6667H7.12501H13.7917H14.2917V12.1667L14.2917 11.3333L14.2917 11.3319C14.2896 10.6421 14.149 9.96281 13.8815 9.33334H15.4583H15.4585C16.1517 9.33315 16.8307 9.52946 17.4169 9.8995C17.9173 10.2154 18.3324 10.6469 18.6286 11.1557C16.7391 13.4924 13.785 15 10.4583 15C8.35674 15 6.57884 14.5769 5.12501 13.8435V7.00149C5.83869 7.18529 6.50843 7.51635 7.09013 7.97573ZM14.5296 1.84278L14.9918 1.65201L14.5296 1.84278C14.6092 2.03552 14.6499 2.24207 14.6494 2.45058C14.6489 2.65909 14.6072 2.86545 14.5268 3.05781C14.4463 3.25017 14.3287 3.42475 14.1806 3.57152L14.179 3.57307L11.2917 6.45961L8.40356 3.57145L8.40357 3.57145L8.40206 3.56996C8.254 3.42314 8.1364 3.24853 8.056 3.05615C7.9756 2.86376 7.93399 2.65739 7.93357 2.44888C7.93314 2.24037 7.9739 2.03383 8.05351 1.84112L7.59139 1.65022L8.05351 1.84112C8.13312 1.6484 8.25001 1.47331 8.39747 1.32589C8.54493 1.17848 8.72005 1.06164 8.91279 0.982081C9.10553 0.902526 9.31208 0.861823 9.52059 0.862309C9.72909 0.862795 9.93545 0.90446 10.1278 0.984912C10.3202 1.06536 10.4948 1.18302 10.6415 1.33113L10.6426 1.33222L10.9376 1.62806L11.2912 1.98261L11.6452 1.62856L11.9402 1.33356L11.9417 1.33206C12.0885 1.184 12.2631 1.06639 12.4555 0.985991C12.6479 0.905593 12.8543 0.863987 13.0628 0.86356C13.2713 0.863133 13.4778 0.903894 13.6706 0.983504C13.8633 1.06311 14.0384 1.18 14.1858 1.32746C14.3332 1.47492 14.45 1.65005 14.5296 1.84278ZM2.95828 6C2.9583 6 2.95832 6 2.95834 6C3.03996 6.00003 3.11874 6.03 3.17974 6.08424C3.23796 6.13602 3.27613 6.20648 3.28779 6.28329L3.29168 6.34828V13.8333C3.29168 13.9217 3.25656 14.0065 3.19405 14.069C3.13153 14.1316 3.04675 14.1667 2.95834 14.1667H1.29168C1.20327 14.1667 1.11849 14.1316 1.05597 14.069C0.993463 14.0065 0.958344 13.9217 0.958344 13.8333V6.33334C0.958344 6.24493 0.993463 6.16015 1.05597 6.09764C1.11849 6.03512 1.20327 6 1.29168 6H2.95828Z"
        fill={color ? color : '#8C8C8C'}
      />
    </svg>
  );
};

const MenuRelease = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 20}
      height={height ? height : 20}
      fill={color ? color : 'none'}
      viewBox="0 0 22 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.20832 6.64V6.95024L3.4863 7.088C4.02884 7.35688 4.48547 7.77198 4.80472 8.2865C5.12396 8.80101 5.29312 9.39449 5.29312 10C5.29312 10.6055 5.12396 11.199 4.80472 11.7135C4.48547 12.228 4.02884 12.6431 3.4863 12.912L3.20832 13.0498V13.36V15.8333V16.3333H3.70832H17.0417H17.5417V15.8333V13.36V13.0498L17.2637 12.912C16.7211 12.6431 16.2645 12.228 15.9453 11.7135C15.626 11.199 15.4569 10.6055 15.4569 10C15.4569 9.39449 15.626 8.80101 15.9453 8.2865C16.2645 7.77198 16.7211 7.35688 17.2637 7.088L17.5417 6.95024V6.64V4.16667V3.66667H17.0417H3.70832H3.20832V4.16667V6.64ZM2.54166 7.4655V3.33333C2.54166 3.24493 2.57678 3.16014 2.63929 3.09763C2.7018 3.03512 2.78658 3 2.87499 3H17.875C17.9634 3 18.0482 3.03512 18.1107 3.09763C18.1732 3.16014 18.2083 3.24493 18.2083 3.33333V7.4655C17.7093 7.56395 17.2465 7.80841 16.8816 8.17331C16.3972 8.65778 16.125 9.31486 16.125 10C16.125 10.6851 16.3972 11.3422 16.8816 11.8267C17.2465 12.1916 17.7093 12.4361 18.2083 12.5345V16.6667C18.2083 16.7551 18.1732 16.8399 18.1107 16.9024C18.0482 16.9649 17.9634 17 17.875 17H2.87499C2.78658 17 2.7018 16.9649 2.63929 16.9024C2.57678 16.8399 2.54166 16.7551 2.54166 16.6667V12.5345C3.04063 12.4361 3.50345 12.1916 3.86835 11.8267C4.35282 11.3422 4.62499 10.6851 4.62499 10C4.62499 9.31486 4.35282 8.65778 3.86835 8.17331C3.50345 7.80841 3.04063 7.56395 2.54166 7.4655ZM8.37499 8H12.375V8.66667H8.37499V8ZM8.37499 11.3333H12.375V12H8.37499V11.3333Z"
        fill={color ? color : '#8C8C8C'}
        stroke={color ? color : '#8C8C8C'}
      />
    </svg>
  );
};

const MenuHistory = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 20}
      height={height ? height : 20}
      fill={color ? color : 'none'}
      viewBox="0 0 22 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.79167 13.375V13.9871L4.39147 13.8649C4.49338 13.8442 4.59911 13.8333 4.70833 13.8333H15.9583H16.4583V13.3333V3.33332V2.83332H15.9583H4.29167H3.79167V3.33332V13.375ZM17.125 14.5H5.125C4.77138 14.5 4.43224 14.6405 4.18219 14.8905C3.93214 15.1406 3.79167 15.4797 3.79167 15.8333C3.79167 16.1869 3.93214 16.5261 4.18219 16.7761C4.43224 17.0262 4.77138 17.1667 5.125 17.1667H17.125V17.8333H5.125C4.59457 17.8333 4.08586 17.6226 3.71079 17.2475C3.33571 16.8725 3.125 16.3638 3.125 15.8333V3.33332C3.125 3.0239 3.24792 2.72716 3.46671 2.50837C3.6855 2.28957 3.98225 2.16666 4.29167 2.16666H17.125V14.5ZM12.9583 6.99999H7.29167V6.33332H12.9583V6.99999Z"
        fill={color ? color : '#595959'}
        stroke={color ? color : '#8C8C8C'}
      />
    </svg>
  );
};

const MenuWhatIsVoucher = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 20}
      height={height ? height : 20}
      fill={color ? color : 'none'}
      viewBox="0 0 22 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.36234 16.3333H7.71648L7.834 15.9993C7.88554 15.8528 7.98128 15.7259 8.10801 15.6361C8.23474 15.5463 8.38621 15.4981 8.5415 15.4981C8.6968 15.4981 8.84827 15.5463 8.975 15.6361C9.10173 15.7259 9.19747 15.8528 9.249 15.9993L9.36653 16.3333H9.72067H17.2915H17.7915V15.8333V13.36V13.0498L17.5135 12.912C16.971 12.6431 16.5144 12.228 16.1951 11.7135C15.8759 11.199 15.7067 10.6055 15.7067 10C15.7067 9.39449 15.8759 8.80101 16.1951 8.2865C16.5144 7.77198 16.971 7.35688 17.5135 7.088L17.7915 6.95024V6.64V4.16667V3.66667H17.2915H9.72067H9.36653L9.249 4.00074C9.19747 4.14724 9.10173 4.27413 8.975 4.36389C8.84827 4.45365 8.6968 4.50186 8.5415 4.50186C8.38621 4.50186 8.23474 4.45365 8.10801 4.36389C7.98128 4.27413 7.88554 4.14724 7.834 4.00074L7.71648 3.66667H7.36234H3.95817H3.45817V4.16667V15.8333V16.3333H3.95817H7.36234ZM2.7915 3.33333C2.7915 3.24493 2.82662 3.16014 2.88913 3.09763C2.95165 3.03512 3.03643 3 3.12484 3H18.1248C18.2132 3 18.298 3.03512 18.3605 3.09763C18.4231 3.16014 18.4582 3.24493 18.4582 3.33333V7.4655C17.9592 7.56395 17.4964 7.80841 17.1315 8.17331C16.647 8.65778 16.3748 9.31486 16.3748 10C16.3748 10.6851 16.647 11.3422 17.1315 11.8267C17.4964 12.1916 17.9592 12.4361 18.4582 12.5345V16.6667C18.4582 16.7551 18.4231 16.8399 18.3605 16.9024C18.298 16.9649 18.2132 17 18.1248 17H3.12484C3.03643 17 2.95165 16.9649 2.88913 16.9024C2.82662 16.8399 2.7915 16.7551 2.7915 16.6667V3.33333ZM8.5415 8.66667C8.34259 8.66667 8.15183 8.58765 8.01117 8.447C7.87052 8.30634 7.7915 8.11558 7.7915 7.91667C7.7915 7.71775 7.87052 7.52699 8.01117 7.38634C8.15183 7.24568 8.34259 7.16667 8.5415 7.16667C8.74042 7.16667 8.93118 7.24568 9.07183 7.38634C9.21249 7.52699 9.2915 7.71775 9.2915 7.91667C9.2915 8.11558 9.21249 8.30634 9.07183 8.447C8.93118 8.58765 8.74042 8.66667 8.5415 8.66667ZM8.5415 12.8333C8.34259 12.8333 8.15183 12.7543 8.01117 12.6137C7.87052 12.473 7.7915 12.2822 7.7915 12.0833C7.7915 11.8844 7.87052 11.6937 8.01117 11.553C8.15183 11.4124 8.34259 11.3333 8.5415 11.3333C8.74042 11.3333 8.93118 11.4124 9.07183 11.553C9.21249 11.6937 9.2915 11.8844 9.2915 12.0833C9.2915 12.2822 9.21249 12.473 9.07183 12.6137C8.93118 12.7543 8.74042 12.8333 8.5415 12.8333Z"
        fill={color ? color : '#434343'}
        stroke={color ? color : '#8C8C8C'}
      />
    </svg>
  );
};

const IconGiftCloseHeader = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="26" height="26" rx="13" fill="url(#paint0_linear_395_3380)" />
      <g clipPath="url(#clip0_395_3380)">
        <path
          d="M14.0002 12.586L18.9502 7.636L20.3642 9.05L15.4142 14L20.3642 18.95L18.9502 20.364L14.0002 15.414L9.05023 20.364L7.63623 18.95L12.5862 14L7.63623 9.05L9.05023 7.636L14.0002 12.586Z"
          fill="black"
        />
      </g>
      <rect x="1" y="1" width="26" height="26" rx="13" stroke="white" strokeWidth="2" />
      <defs>
        <linearGradient
          id="paint0_linear_395_3380"
          x1="13.499"
          y1="47.9427"
          x2="15.5148"
          y2="-0.948737"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFFFF" stopOpacity="1" />
          <stop offset="1" stopColor="#FFFFFF" />
        </linearGradient>
        <clipPath id="clip0_395_3380">
          <rect width="24" height="24" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const IconVoucherCloseHeader = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="26" height="26" rx="13" fill="url(#paint0_linear_405_5102)" />
      <g clipPath="url(#clip0_405_5102)">
        <path
          d="M14.0002 12.586L18.9502 7.636L20.3642 9.05L15.4142 14L20.3642 18.95L18.9502 20.364L14.0002 15.414L9.05023 20.364L7.63623 18.95L12.5862 14L7.63623 9.05L9.05023 7.636L14.0002 12.586Z"
          fill="white"
        />
      </g>
      <rect x="1" y="1" width="26" height="26" rx="13" stroke="white" strokeWidth="2" />
      <defs>
        <linearGradient
          id="paint0_linear_405_5102"
          x1="5.39428e-05"
          y1="1365"
          x2="36.3417"
          y2="1364.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0279465" stopColor="#875928" />
          <stop offset="0.660171" stopColor="#F0D99D" />
        </linearGradient>
        <clipPath id="clip0_405_5102">
          <rect width="24" height="24" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const IconPlus = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 12}
      height={height ? height : 12}
      fill={color ? color : 'none'}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.46863 0.375732H5.53113C5.44779 0.375732 5.40613 0.417399 5.40613 0.500732V5.40698H0.750244C0.666911 5.40698 0.625244 5.44865 0.625244 5.53198V6.46948C0.625244 6.55282 0.666911 6.59448 0.750244 6.59448H5.40613V11.5007C5.40613 11.5841 5.44779 11.6257 5.53113 11.6257H6.46863C6.55196 11.6257 6.59363 11.5841 6.59363 11.5007V6.59448H11.2502C11.3336 6.59448 11.3752 6.55282 11.3752 6.46948V5.53198C11.3752 5.44865 11.3336 5.40698 11.2502 5.40698H6.59363V0.500732C6.59363 0.417399 6.55196 0.375732 6.46863 0.375732Z"
        fill={color ? color : 'black'}
        fillOpacity="0.85"
      />
    </svg>
  );
};

const IconInfoOneStop = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1809_34746)">
        <rect x="0.5" width="24" height="24" rx="12" fill="#B37FEB" />
        <path
          d="M12.5 22C6.977 22 2.5 17.523 2.5 12C2.5 6.477 6.977 2 12.5 2C18.023 2 22.5 6.477 22.5 12C22.5 17.523 18.023 22 12.5 22ZM12.5 20C14.6217 20 16.6566 19.1571 18.1569 17.6569C19.6571 16.1566 20.5 14.1217 20.5 12C20.5 9.87827 19.6571 7.84344 18.1569 6.34315C16.6566 4.84285 14.6217 4 12.5 4C10.3783 4 8.34344 4.84285 6.84315 6.34315C5.34285 7.84344 4.5 9.87827 4.5 12C4.5 14.1217 5.34285 16.1566 6.84315 17.6569C8.34344 19.1571 10.3783 20 12.5 20Z"
          fill="white"
        />
        <path
          d="M11.5 12L11.5 16C11.5 16.5523 11.9477 17 12.5 17C13.0523 17 13.5 16.5523 13.5 16L13.5 12C13.5 11.4477 13.0523 11 12.5 11C11.9477 11 11.5 11.4477 11.5 12Z"
          fill="white"
        />
        <path
          d="M13.5 8C13.5 7.44771 13.0523 7 12.5 7C11.9477 7 11.5 7.44771 11.5 8C11.5 8.55229 11.9477 9 12.5 9C13.0523 9 13.5 8.55229 13.5 8Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1809_34746">
          <rect x="0.5" width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const IconCloseModal = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 14}
      height={height ? height : 14}
      fill={color ? color : 'none'}
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2502 0L6.99938 5.24954L1.74984 0L0 1.74985L5.24954 6.99938L0 12.2489L1.74984 13.9988L6.99938 8.74923L12.2502 13.9988L14 12.2489L8.75046 6.99938L14 1.74985L12.2502 0Z"
        fill={color ? color : 'white'}
      />
    </svg>
  );
};

const IconCloseImage = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 28}
      height={height ? height : 28}
      fill={color ? color : 'none'}
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="26" height="26" rx="13" fill="url(#paint0_linear_2377_6237)" />
      <g clipPath="url(#clip0_2377_6237)">
        <path
          d="M14 12.586L18.95 7.63599L20.364 9.04999L15.414 14L20.364 18.95L18.95 20.364L14 15.414L9.04999 20.364L7.63599 18.95L12.586 14L7.63599 9.04999L9.04999 7.63599L14 12.586Z"
          fill={color ? color : 'white'}
        />
      </g>
      <rect x="1" y="1" width="26" height="26" rx="13" stroke="white" strokeWidth="2" />
      <defs>
        <linearGradient
          id="paint0_linear_2377_6237"
          x1="13.499"
          y1="47.9427"
          x2="15.5148"
          y2="-0.948737"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000000" stopOpacity="0.3" />
          <stop offset="1" stopColor="#000000" />
        </linearGradient>
        <clipPath id="clip0_2377_6237">
          <rect width="24" height="24" fill="#000000" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const IconDisplayDatetime = () => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_81_656)">
        <path
          d="M8.49998 14.6666C4.81798 14.6666 1.83331 11.682 1.83331 7.99998C1.83331 4.31798 4.81798 1.33331 8.49998 1.33331C12.182 1.33331 15.1666 4.31798 15.1666 7.99998C15.1666 11.682 12.182 14.6666 8.49998 14.6666ZM8.49998 13.3333C9.91447 13.3333 11.271 12.7714 12.2712 11.7712C13.2714 10.771 13.8333 9.41447 13.8333 7.99998C13.8333 6.58549 13.2714 5.22894 12.2712 4.22874C11.271 3.22855 9.91447 2.66665 8.49998 2.66665C7.08549 2.66665 5.72894 3.22855 4.72874 4.22874C3.72855 5.22894 3.16665 6.58549 3.16665 7.99998C3.16665 9.41447 3.72855 10.771 4.72874 11.7712C5.72894 12.7714 7.08549 13.3333 8.49998 13.3333ZM9.16665 7.99998H11.8333V9.33331H7.83331V4.66665H9.16665V7.99998Z"
          fill="#595959"
        />
      </g>
      <defs>
        <clipPath id="clip0_81_656">
          <rect width="16" height="16" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const IconEdit = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width={width ? width : 10}
      height={height ? height : 10}
      fill={color ? color : 'none'}
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.45 2.42898L7.571 4.55048L2.621 9.49998H0.5V7.37848L5.45 2.42848V2.42898ZM6.157 1.72198L7.2175 0.660981C7.31126 0.567245 7.43842 0.514587 7.571 0.514587C7.70358 0.514587 7.83074 0.567245 7.9245 0.660981L9.339 2.07548C9.43274 2.16924 9.48539 2.2964 9.48539 2.42898C9.48539 2.56156 9.43274 2.68872 9.339 2.78248L8.278 3.84298L6.157 1.72198Z"
        fill={color ? color : 'white'}
      />
    </svg>
  );
};

const IconClock = ({ color, width, height, className }: any) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00001 14.1666C3.31801 14.1666 0.333344 11.182 0.333344 7.49998C0.333344 3.81798 3.31801 0.833313 7.00001 0.833313C10.682 0.833313 13.6667 3.81798 13.6667 7.49998C13.6667 11.182 10.682 14.1666 7.00001 14.1666ZM7.00001 12.8333C8.4145 12.8333 9.77105 12.2714 10.7712 11.2712C11.7714 10.271 12.3333 8.91447 12.3333 7.49998C12.3333 6.08549 11.7714 4.72894 10.7712 3.72874C9.77105 2.72855 8.4145 2.16665 7.00001 2.16665C5.58552 2.16665 4.22897 2.72855 3.22877 3.72874C2.22858 4.72894 1.66668 6.08549 1.66668 7.49998C1.66668 8.91447 2.22858 10.271 3.22877 11.2712C4.22897 12.2714 5.58552 12.8333 7.00001 12.8333ZM7.66668 7.49998H10.3333V8.83331H6.33334V4.16665H7.66668V7.49998Z"
        fill={color ? color : 'black'}
      />
    </svg>
  );
};

export {
  MenuIcon,
  ComeBackIcon,
  V2ComeBackIcon,
  ClockIcon,
  PhotoFrames,
  EditIcon,
  VisaIcon,
  MastercardIcon,
  ScanIcon,
  MenuHome,
  MenuWhatIs,
  MenuRelease,
  MenuHistory,
  MenuWhatIsVoucher,
  IconGiftCloseHeader,
  IconVoucherCloseHeader,
  IconPlus,
  SuccessfulFuru,
  SuccessfulVoucher,
  NoImage,
  IconInfoOneStop,
  IconCloseModal,
  IconDisplayDatetime,
  IconCloseImage,
  IconEdit,
  IconClock,
};
